import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { addCompanyNote } from "../api/addCompanyNote";

export const useAddCompanyNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, note }) => addCompanyNote({ companyId, note }),
    onSuccess: (_, variables) => {
      toast.success("Note added successfully!");
      queryClient.invalidateQueries({ queryKey: ["companyNotes", variables.companyId] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to add note.");
    },
  });
};

